exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".json-schema {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-width: 600px;\n}\n.json-schema .header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n}\n.json-schema .header .ant-typography {\n  margin-top: 3px;\n  margin-bottom: 0;\n}\n.json-schema .json-view-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  border: 1px solid #e4e5ed;\n  border-radius: 4px;\n  overflow: auto;\n  padding: 10px 15px;\n}\n.json-schema .json-view-container .error {\n  color: #ff4d4f;\n  overflow-wrap: break-word;\n}\n", ""]);

// exports
